import addChecklistAction from "./addChecklistAction";
import editChecklistAction from "./editChecklistAction";
import addChecklistItem from "./addChecklistItemAction";
import editChecklistItem from "./editChecklistItemAction";
import removeChecklistItem from "./removeChecklistItemAction";
import removeChecklistAction from "./removeChecklistAction";

import {
    CHECKLIST_ADD_ITEM,
    CHECKLIST_CLEAR_STATE,
    CHECKLIST_REMOVE_ITEM,
    CHECKLIST_SAVE_ITEM,
    CHECKLIST_SAVE_LABEL,
    CHECKLIST_SAVE_DESCRIPTION,
    CHECKLIST_SET_CHECKLISTS,
    CHECKLIST_SET_CURRENT_STATE,
    CHECKLIST_SET_CHECKLIST,
    CHECKLIST_SAVE_CHECKLIST,
    CHECKLIST_SET_MODE,
    CHECKLIST_SELECT_CHECKLIST,
    CHECKLIST_SET_LOADING,
    CHECKLIST_SET_CURRENT_CHECKLIST,
    CHECKLIST_REORDER_ITEMS
} from "../types";

function removeItem(index) {
    return {
        type: CHECKLIST_REMOVE_ITEM,
        index
    };
}

function saveLabel(label) {
    return {
        type: CHECKLIST_SAVE_LABEL,
        label
    };
}

function saveDescription(description) {
    return {
        type: CHECKLIST_SAVE_DESCRIPTION,
        description
    };
}

function addItem() {
    return {
        type: CHECKLIST_ADD_ITEM,
        item: {label: "", type: "CHECKBOX", error: ""}
    };
}

function saveItem(index, item) {
    return {
        type: CHECKLIST_SAVE_ITEM,
        index,
        item
    };
}

function clearState() {
    return {
        type: CHECKLIST_CLEAR_STATE
    };
}

function setChecklists(checklists) {
    return {
        type: CHECKLIST_SET_CHECKLISTS,
        checklists
    };
}

function setCurrentState(currentState) {
    return {
        type: CHECKLIST_SET_CURRENT_STATE,
        currentState
    };
}

function setChecklist(checklist) {
    return {
        type: CHECKLIST_SET_CHECKLIST,
        checklist
    };
}

function setMode(mode) {
    return {
        type: CHECKLIST_SET_MODE,
        mode
    };
}

function saveChecklist(checklist) {
    return {
        type: CHECKLIST_SAVE_CHECKLIST,
        checklist
    };
}

function selectChecklist(checklist) {
    return {
        type: CHECKLIST_SELECT_CHECKLIST,
        checklist
    };
}

function setLoading(loading) {
    return {
        type: CHECKLIST_SET_LOADING,
        loading
    };
}

function setCurrentChecklist(checklist) {
    return {
        type: CHECKLIST_SET_CURRENT_CHECKLIST,
        checklist
    };
}

function reorderItems(fromIndex, toIndex) {
    return {
        type: CHECKLIST_REORDER_ITEMS,
        fromIndex,
        toIndex
    };
}

export {
    addItem,
    removeItem,
    saveItem,
    clearState,
    addChecklistItem,
    addChecklistAction,
    removeChecklistItem,
    removeChecklistAction,
    editChecklistItem,
    editChecklistAction,
    setMode,
    setChecklists,
    setCurrentState,
    saveLabel,
    saveDescription,
    setChecklist,
    saveChecklist,
    selectChecklist,
    setLoading,
    setCurrentChecklist,
    reorderItems
};
